import { render, staticRenderFns } from "./FollowUpPatientStep8Component.vue?vue&type=template&id=4ec5c40c&scoped=true&"
import script from "./FollowUpPatientStep8Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep8Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep8Component.vue?vue&type=style&index=0&id=4ec5c40c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec5c40c",
  null
  
)

export default component.exports